import React, { FunctionComponent } from "react";
import { Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

import { useStylesV2 } from "../stylesV2";
// import MediaItem from "./MediaItem";
import ErrorMessage from "components/Error/ErrorMessage";
import MediaItemV2 from "./MediaItemV2";

interface MediaProps {
  posts: Array<any>;
  role: string;
  igMetadata?: any;
  fbMetadata?: any;
}
const Media: FunctionComponent<MediaProps> = ({
  posts,
  role,
  igMetadata,
  fbMetadata,
}) => {
  const classes = useStylesV2({});
  let postsMarkup;
  if (posts?.length > 0) {
    postsMarkup = posts.map((post, index) => (
      <MediaItemV2
        post={post}
        key={index}
        role={role}
        fbMetadata={fbMetadata}
        igMetadata={igMetadata}
      />
    ));
  }

  const message = !["YouTube", "twitter"].includes(role)
    ? "These are the posts that have the highest reach which were posted in the chosen period."
    : ["twitter"].includes(role)
    ? "These are the posts that have the highest impressions which were posted in the chosen period."
    : "These are the posts that have the highest views and likes which were posted in the chosen period." +
      `${
        role === "instagram"
          ? " IGTV and Reel posts are not displayed because the Instagram API does not provide this data"
          : ""
      }`;

  return (
    <div
      style={{ marginBottom: "0px" }}
      id={`${role}-Top 3 highest engagement posts`}
    >
      <div
        className={classes.statsName}
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "20px",
          padding: "30px 0px 25px 0px",
          fontFamily: "Avenir Book, sans-serif",
          fontWeight: 900,
        }}
      >
        {!["facebook", "YouTube", "twitter"].includes(role) && (
          <span>Top 3 Highest Engagement Posts</span>
        )}
        {role === "twitter" && <span>Top 3 Post By Impressions</span>}
        {role === "YouTube" && <span>Top 3 Post By Views and Likes</span>}
        {role === "facebook" && <span>Top 3 Post By Likes and Comments</span>}
        <Tooltip
          title={message}
          arrow
          interactive
          classes={{ tooltip: classes.info }}
        >
          <InfoIcon />
        </Tooltip>
      </div>
      {posts?.length === 0 ? (
        <ErrorMessage message=" No available posts for this period" />
      ) : (
        <div className={classes.media} id="media">
          {postsMarkup}
        </div>
      )}
    </div>
  );
};

const areEqual = (prevProps, nextProps): any => {
  if (prevProps.posts === nextProps.posts) {
    return true;
  }
};

export default React.memo(Media, areEqual);
